import { DropdownMenu as DropdownMenuRadix } from "radix-ui";
import {
  type MouseEventHandler,
  type PropsWithChildren,
  type ReactNode,
} from "react";

import { cn } from "$/lib/utils/functions/misc.functions";

type Props = {
  trigger: ReactNode;
  triggerContainerClassName?: string;
  className?: string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  alignToTrigger?: "default" | "bottom-center";
  onClick?: MouseEventHandler<HTMLButtonElement> | undefined;
  sideOffset?: number;
  modal?: boolean;
  onContentMouseEnter?: MouseEventHandler<HTMLDivElement>;
  onContentMouseLeave?: MouseEventHandler<HTMLDivElement>;
};

const DropdownMenu = ({
  trigger,
  triggerContainerClassName,
  className,
  open,
  onClick,
  children,
  onOpenChange,
  alignToTrigger = "default",
  sideOffset = 6,
  modal,
  onContentMouseEnter,
  onContentMouseLeave,
}: PropsWithChildren<Props>) => {
  return (
    <DropdownMenuRadix.Root
      open={open}
      onOpenChange={onOpenChange}
      modal={modal}
    >
      <DropdownMenuRadix.Trigger
        className={triggerContainerClassName}
        onClick={onClick}
        asChild
      >
        {trigger}
      </DropdownMenuRadix.Trigger>
      <DropdownMenuRadix.Portal>
        <div className="z-[10000]">
          <DropdownMenuRadix.Content
            side={alignToTrigger === "bottom-center" ? "bottom" : undefined}
            align={alignToTrigger === "bottom-center" ? "center" : undefined}
            sideOffset={
              alignToTrigger === "bottom-center" ? sideOffset : undefined
            }
            onMouseEnter={onContentMouseEnter}
            onMouseLeave={onContentMouseLeave}
            className={cn(
              "z-[10000] min-w-[155px] max-w-[calc(100vw-1rem)] rounded-xl bg-white p-5 shadow-[0px_10px_38px_-10px_rgba(22,_23,_24,_0.35),_0px_10px_20px_-15px_rgba(22,_23,_24,_0.2)] will-change-[opacity,transform]",
              {
                // 👉 comportement historique conservé
                "right-1/2 translate-x-1/4": alignToTrigger === "default",
              },
              "origin-[var(--radix-dropdown-menu-content-transform-origin)]",
              className,
            )}
          >
            {children}
          </DropdownMenuRadix.Content>
        </div>
      </DropdownMenuRadix.Portal>
    </DropdownMenuRadix.Root>
  );
};

export default DropdownMenu;
